/**
 * **eZee**
 *
 * @exports bs_298
 * @category engines
 */
function factory({ window, document, thn }) {

  const engine = {};

  /**
   * @memberOf module:bs_298
   * @see {@link prestart}
   *
   * @param {object} ctx - The context object.
   */
  engine.boot = function boot() {
    const refreshPage = thn.debounce(({ message }) => {
      if (message.event === 'purchase') {
        thn.pageCheck();
      }
    }, 100);
    thn.bus.on('dataLayer:push', refreshPage, true);
    thn.shutdown(() => {
      thn.bus.detach('dataLayer:push', refreshPage);
    });
  };

  /**
     * @memberOf module:bs_298
     * @see {@link language_check}
     *
     * @param {object} ctx - The context object.
     */
  engine.languageCheck = function languageCheck(ctx) {

    return new Promise(function (resolve, reject) {
      if (thn.data.propertyId === 1027345 && window.location.hostname === 'www.royalpalmgalapagos.com') {
        resolve('en');
      }

      reject('no_language');
    });
  };

  /**
     * @memberOf module:bs_298
     * @see {@link onStateChange}
     *
     * @param {object} ctx - The context object.
     */
  engine.onStateChange = function onStateChange() {

    const shouldCheckPage = [
      1026633, 1049466,
    ].includes(thn.data.propertyId);
    if (shouldCheckPage) {
      thn.pageCheck();
    }
  };

  const HotelIdMap = {
    1049466: 92, // Arena Beach Hotel
    1026633: 12327, // Aarunya Nature Resort and Spa
    1026894: 11241, // LANTERN BOUTIQUE HOTEL - MIRISSA
    1026895: 11331, // UBUNTU BEACH VILLAS - MIRISSA
    1026903: 18114, // THE BEACH HOUSE - MIRISSA
    1027338: 13272, // Feliz Hotel Boracay
    1027633: 19097, // Nichols Airport Hotel
    1028919: 21813, // Menzeh Dalia
    1035375: 14165, // The Riverside Hotel and Spa
    1037105: 6764, // Season Paradise
    1037128: 428, // The Somerset Hotel
    1037266: 22300, // Sundara by Mosvold
    1037350: 12853, // Tabula Rasa Resort
  };

  engine.generateSearchUrl = function generateSearchUrl(ctx) {
    const url = new URL(ctx.baseUrl);
    const validUrl = url.hostname.match(/ipms247/) && url.pathname.match(/booking/);
    const hotelCode = HotelIdMap[thn.data.propertyId]
    || thn.parseNumber(document.querySelector('#hotel_code')?.value);

    // https://live.ipms247.com/booking/searchroom_ghf.php?HotelId=92&checkin=2024-12-11&nonights=1&adults=2&children=0
    if (!validUrl && !hotelCode) {
      ctx.newUrl = '';
      return ctx;
    }

    url.hostname = 'live.ipms247.com';
    url.pathname = '/booking/searchroom_ghf.php';
    url.searchParams.set('HotelId', hotelCode);
    url.searchParams.set('checkin', ctx.data.dateBegin.replace(/\//g, '-'));
    url.searchParams.set('nonights', thn.daysBetween(ctx.data.dateBegin, ctx.data.dateEnd));
    url.searchParams.set('adults', ctx.data.adults);
    url.searchParams.set('children', ctx.data.children);

    ctx.newUrl = url.toString();

    return ctx;
  };

  /**
     * @memberOf module:bs_298
     * @this thn.widgets.price
     * @see {@link Price#observe_dom}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceObserveDom = function priceObserveDom(ctx) {
    const container = document.querySelector('#eZ_BookingRooms');

    if (container && !thn.ezeeObserver) {
      thn.ezeeObserver = thn.debounce(() => ctx.widget.refresh(), 800);

      thn.observeDom(container, thn.ezeeObserver, {
        childList: true,
        subtree: true,
        attributes: false,
      });

      thn.pageUnload(() => {
        thn.stopObserveDom(container, thn.ezeeObserver);
        delete thn.ezeeObserver;
      });
    }
  };

  /**
     * @memberOf module:bs_298
     * @this thn.widgets.price
     * @see {@link Price#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceParseData = function priceParseData(ctx) {

    const widgetData = {};

    const usersWithDifferentOrderRates = [1037569];

    // Dates
    const dateBegin = (document.querySelector('#eZ_chkin') || {}).value;
    const dateEnd = (document.querySelector('#eZ_chkout') || {}).value;

    if (dateBegin && dateEnd) {
      widgetData.dateBegin = dateBegin.replace(/(\d+)\D+(\d+)\D+(\d+)/, (usersWithDifferentOrderRates.includes(thn.data.accountUserId)) ? '$3/$1/$2' : '$3/$2/$1');
      widgetData.dateEnd = dateEnd.replace(/(\d+)\D+(\d+)\D+(\d+)/, (usersWithDifferentOrderRates.includes(thn.data.accountUserId)) ? '$3/$1/$2' : '$3/$2/$1');
    }

    // In this BE there's a filter to show the price per night or the total sum, we need to check which type of price we're seeing
    // By default is in Price per night
    // Example: https://live.ipms247.com/booking/book-rooms-aquastarhotelapartments-en-English
    let nights = 1;
    if (widgetData.dateBegin && widgetData.dateEnd && !document.querySelector('#pnl_avg_blk.active')) {
      nights = thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
    }

    // Guests, Adults & Children & Price
    /**
         * In this BE we need to do an specific logic to obtain the correct values for the guests. Some hotels have disabled those inputs in the form.
         * We have two ways to know the occupancy:
         *  - Way 1: There's a element in the left that shows the number of adults and guest for that room (with logos). We should try to obtain the occupancy from those elements because
         *    if those elements does exists, the other way to obtain them is not so quite reliable. Except when there's no information about the number of children, this elements will should the maximum occupancy
         *      - Example for when we should obtain values from that element --> https://live.ipms247.com/booking/book-rooms-citynitesservicedapartments
         *      - Example for when we shouldn't obtain values from that element --> https://live.ipms247.com/booking/book-rooms-aquastarhotelapartments
         *  - Way 2: There's a element under the price that shows the occupancy, this way is suitable when we can find the information about the occupancy when the previous way is not reliable (there's no element for children)
         *      - Example --> https://live.ipms247.com/booking/book-rooms-aarunyanatureresort-en-English
         */

    // Exception for guests on this user_account
    const useForcedGuests = thn.data.accountUserId === 1037569;

    // In the general case "forced_guests" will be empty
    const forcedGuests = !useForcedGuests ? {} : {
      adults: 2,
      children: 0,
    };

    // Get all the important information of the room, and then, get the cheapest room and get the occupancy of it
    const roomInfo = [...document.querySelectorAll('[id^=row_]:not([id^=row_index]):not(.hidereadmore):not([style*="display: none"])')].map(function (el) {

      // Check if the room satisfies the minimum amout of nights if not avoid this room
      if (el.querySelector('.minnightschk')) {
        return {};
      }

      let priceEl = el.querySelector('.averagepernight .pre_currency > strong:not(.strike_strong_cls) > span');

      let price = priceEl && thn.parseNumber(priceEl.textContent);

      // Is some cases there is no .averagepernight container. In this cases, we take price for whole stay and divide per nights.
      if (!price) {
        priceEl = el.querySelector('.priceforwholestay .pre_currency > strong:not(.strike_strong_cls) > span');
        price = priceEl && thn.parseNumber(priceEl.textContent) / nights;
      }

      const guests = {
        adults: thn.parseNumber((el.querySelector('[id^=base_adult_occ]') || {}).textContent) || 2,
        children: thn.parseNumber((el.querySelector('[id^=base_child_occ]') || {}).textContent) || 0,
      };

      return {
        price,
        ...guests,
        ...forcedGuests,
      };
    }).filter((room) => room.price && room.adults);

    let cheapestRoom;
    // Get cheapest room
    if (roomInfo.length) {
      const price = Math.min(...roomInfo.map((room) => room.price));
      cheapestRoom = roomInfo.filter((el) => el.price === price)[0];
    }

    // If the search has no results (it does not take into account filtering)
    const isNoRoomsElementVisible = thn.isVisible(document.querySelector('#no_record'));

    if (cheapestRoom) {
      widgetData.adults = cheapestRoom.adults;
      widgetData.children = cheapestRoom.children;
      widgetData.guests = widgetData.adults + widgetData.children;
      widgetData.price = cheapestRoom.price;
      widgetData.currency = document.querySelector('.currname')?.textContent || 'USD';
      widgetData.set = true;

    } else if (isNoRoomsElementVisible) {
      widgetData.noRooms = true;
    } else {
      widgetData.set = false;
    }

    return widgetData;
  };

  /**
     * @memberOf module:bs_298
     * @this thn.widgets.booking
     * @see {@link Booking#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.bookingParseData = function bookingParseData(ctx) {

    const widgetData = {};

    function formatNumber(num) {
      return typeof thn.parseNumber(num) === 'number' && (thn.parseNumber(num) / 100).toFixed(2);
    }

    const dLObj = window.dataLayer?.find((item) => item[1] === 'purchase')?.[2];
    const bookingIdNumber = thn.parseNumber(document.querySelector('.vres-payment-msg')?.textContent) || thn.parseNumber(document.querySelector('.vres-bcdescription p')?.innerText);
    const bookingId = thn.parseUrlParameter('ordernumber') || thn.objectGet(dLObj, 'transaction_id')?.replace(/\d+_/, '') || bookingIdNumber?.toString() || document.querySelector('[class*=booking-details-container] small b:last-child, .booking-det b')?.textContent;
    const isDirectBooking = (bookingNum) => bookingNum?.split('/').length === 1;
    const shouldIgnoreBooking = (bookingNum) => thn.data.accountUserId === 1042623 && !isDirectBooking(bookingNum);

    if (!bookingId || shouldIgnoreBooking(bookingId)) {
      widgetData.set = false;
      return widgetData;
    }

    const bookingParams = new URLSearchParams(document.querySelector('.TAPixel')?.src);
    const dateBeginSearchParam = bookingParams?.get('start_date');
    const dateEndSearchParam = bookingParams?.get('end_date');
    const dateBegin = document.querySelector('[class*=guestdetails] p:nth-child(6)')?.textContent?.match(/\d{4}-\d{2}-\d{2}/)?.toString()?.replace(/-/g, '/')
      || document.querySelector('[class*=guestdetails] p:nth-child(6)')?.textContent?.replace(/\D+(\d{2})\D(\d{2})\D(\d{4})\D+/, '$3/$1/$2')
      || dateBeginSearchParam?.replace(/-/g, '/');
    const dateEnd = document.querySelector('[class*=guestdetails] p:nth-child(7)')?.textContent?.match(/\d{4}-\d{2}-\d{2}/)?.toString()?.replace(/-/g, '/')
      || document.querySelector('[class*=guestdetails] p:nth-child(7)')?.textContent?.replace(/\D+(\d{2})\D(\d{2})\D(\d{4})\D+/, '$3/$1/$2')
      || dateEndSearchParam?.replace(/-/g, '/');

    if (dateBegin && dateEnd) {
      widgetData.dateBegin = dateBegin;
      widgetData.dateEnd = dateEnd;
    }

    widgetData.bookingId = bookingId;

    // Depending of the property on "Total Paid" can be 0, we need to check that the prie is not zero
    // If yes, we should get "Grand Total"
    const price = thn.parseNumber(thn.objectGet(dLObj, 'value')) || thn.parseNumber(document.querySelector('div[class*=ratesdetails] tbody > tr:nth-child(5) > td:last-child ')?.textContent)
      || thn.parseNumber(document.querySelector('div[class*=ratesdetails] tbody > tr:nth-child(7) > td:last-child')?.textContent)
      || thn.parseNumber(formatNumber(bookingParams?.get('fees')));

    let currency = thn.objectGet(dLObj, 'currency') || thn.parseCurrency(document.querySelector('div[class*=ratesdetails] tbody > tr:nth-child(5) > td:last-child, div[class*=ratesdetails] tbody > tr:nth-child(7) > td:last-child')?.textContent) || bookingParams?.get('currency');

    // On Feliz Hotel Boracay, we cannot the "PHP" currency is represented as "P"
    if (!currency && document.querySelector('div[class*=ratesdetails] tbody > tr:nth-child(5) > td:last-child, div[class*=ratesdetails] tbody > tr:nth-child(7) > td:last-child')?.textContent?.match(/^\s?P/)) {
      currency = 'PHP';
    }

    if (price && currency) {
      widgetData.price = price;
      widgetData.currency = currency;
    }

    return widgetData;
  };

  engine.getPromocode = function getPromocode(ctx) {
    const promo = document.querySelector('#promotioncode') && document.querySelector('#promotioncode').getAttribute('value');
    if (promo) {
      ctx.promocode = promo;
    }
    return ctx.promocode;
  };

  return engine;

}

export { factory };
